<template>
    <v-dialog v-model="internalDialog" max-width="500" persistent>
        <v-card class="pa-3 text-center">
            <!-- Icon -->
            <div class="text-center">
                <v-icon class="dialog-icon" size="x-large" color="warning">
                    mdi-clock-alert-outline
                </v-icon>
            </div>

            <!-- Title -->
            <v-card-title class="text-center pt-4">
                <b class="dialog-title">Session Timeout</b>
            </v-card-title>

            <!-- Message -->
            <v-card-subtitle class="dialog-subtitle pa-6">
                <span>Your session has expired. Please login again to continue.</span>
            </v-card-subtitle>

            <!-- Actions -->
            <v-card-actions class="justify-center pb-6">
                <v-btn variant="flat" color="error" class="action-btn" @click="handleLogin">
                    Login Again
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "DialogSessionTimeout",
    props: {
        dialog: { type: Boolean, default: false }
    },
    emits: ["update:dialog", "login"],
    data() {
        return {
            internalDialog: this.dialog
        };
    },
    watch: {
        dialog(newVal) {
            console.log('📱 Dialog prop received:', newVal);
            this.internalDialog = newVal;
        },
        internalDialog(newVal) {
            this.$emit("update:dialog", newVal);
        }
    },
    methods: {
        handleLogin() {
            console.log('🔐 Login button clicked');
            this.$emit("login");
        }
    },
    mounted() {
        console.log('📱 DialogSessionTimeout mounted');
    }
};
</script>

<style scoped>
.v-dialog > .v-overlay__content > .v-card {
    border-radius: 15px;
}

.dialog-icon {
    font-size: 80px;
}

.dialog-title {
    font-size: 24px;
    font-weight: 700;
}

.dialog-subtitle {
    font-size: 16px;
    font-weight: 500;
    word-wrap: break-word;
    white-space: normal;
}

.action-btn {
    width: 150px !important;
    height: 40px !important;
    border-radius: 20px !important;
    padding: 8px 24px !important;
    font-family: Gilroy, sans-serif;
    font-size: 14px;
    font-weight: 700;
    text-transform: none;
    letter-spacing: 0;
}
</style>